import Cookies from "js-cookie"
import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CookiesKeys, URLs } from '../../Constants/Consts'
import { fetchApi } from '../../Helpers/Functions'
import { setDrilldownMappingsAPIResponse } from '../../store/SequenceObject'
import { updateDownloadTriggered, updateHasDownloadedValue } from '../../store/Utilities'
import { RootState } from '../../store/store'

export default function storeDrilldownMappings() {
    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    const { downloadTriggered: { drilldownMappings: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)
    React.useEffect(() => {
        (async () => {
            if (navigator.onLine && SelectedUser.jwt && currentToken && (!calledOnceRef.current || triggered)) {
                calledOnceRef.current = true
                setIsloading(true)
                const drillDownMappings = await fetchApi(
                    URLs.getChecklistDrillDownTypes())
                    .then(res => res.json())
                // update store
                dispatch(setDrilldownMappingsAPIResponse(drillDownMappings))
                dispatch(updateHasDownloadedValue({ key: "drilldownMappings", value: true }))
                dispatch(updateDownloadTriggered({ key: "drilldownMappings", value: false }))
                setIsloading(false)
            }
        })()
    }, [SelectedUser.jwt, triggered])

    return { isloading }
}
